import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import { useApplication } from '@/context/application.provider';

import { Route } from './types';

const AccountCreation = lazy(() => import('@/pages/AccountCreation/index'));
const PageNotFound = lazy(() => import('@/pages/PageNotFound/index'));
const Login = lazy(() => import('@/pages/Login/index'));
const AccountRecover = lazy(() => import('@/pages/RecoverAccount/index'));
const ChangePassword = lazy(() => import('@/pages/ChangePassword/index'));

const ChangePasswordWrapper = () => {
  const { recoverAccount } = useApplication();
  const { isAuthorized } = recoverAccount;

  return isAuthorized ? <ChangePassword /> : <Navigate replace to="/recover-account" />;
};

export const publicRoutes: Route = {
  accountCreation: {
    Component: AccountCreation,
    path: '/account-creation',
  },
  changePassword: {
    Component: ChangePasswordWrapper,
    path: '/change-password',
  },
  login: {
    Component: Login,
    path: '/login',
  },
  pageNotFound: {
    Component: PageNotFound,
    path: '*',
  },
  recoverAccount: {
    Component: AccountRecover,
    path: '/recover-account',
  },
  root: {
    Component: () => <Navigate replace to="/login" />,
    path: '/',
  },
};
